import React, { useMemo, useState } from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import HowItWorksSection from '../components/HowItWorksSection';
import PartnerskaSection from '../components/PartnerskaSection';
import RozluckovaSection from '../components/RozluckovaSection';
import PricingSection from '../components/PricingSection';
import ExamplesSection from '../components/ExamplesSection';
import FAQSection from '../components/FAQSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import CookieBanner from "../components/CookieBanner";

const LandingPage = () => {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const stripeStatus = params.get('stripe');
  const orderId = params.get('order_id');

  const [showStripeMessage, setShowStripeMessage] = useState(
    stripeStatus === 'success' || stripeStatus === 'cancel'
  );

  const closeStripeMessage = () => {
    setShowStripeMessage(false);

    const url = new URL(window.location.href);
    url.searchParams.delete('stripe');
    url.searchParams.delete('order_id');
    window.history.replaceState({}, '', url.pathname + url.search);
  };

  return (
    <div className="landing-page">
      <Navigation />

      {showStripeMessage && stripeStatus === 'success' && (
        <div className="max-w-4xl mx-auto px-4 pt-6">
          <div className="bg-green-50 border border-green-200 rounded-2xl px-5 py-4 text-green-900 shadow-sm">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h2 className="text-lg font-semibold mb-1">
                  🎉 Platba proběhla úspěšně
                </h2>
                <p className="text-sm mb-2">
                  Děkujeme, vaše objednávka byla úspěšně přijata.
                </p>
                <p className="text-sm">
                  Potvrzení jsme odeslali na váš e-mail a výzva bude zpracována
                  podle nastavení.
                </p>
                {orderId && (
                  <p className="text-xs mt-2 opacity-75">
                    ID objednávky: {orderId}
                  </p>
                )}
              </div>

              <button
                type="button"
                onClick={closeStripeMessage}
                className="text-sm font-medium opacity-70 hover:opacity-100"
                aria-label="Zavřít oznámení"
              >
                Zavřít
              </button>
            </div>
          </div>
        </div>
      )}

      {showStripeMessage && stripeStatus === 'cancel' && (
        <div className="max-w-4xl mx-auto px-4 pt-6">
          <div className="bg-amber-50 border border-amber-200 rounded-2xl px-5 py-4 text-amber-900 shadow-sm">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h2 className="text-lg font-semibold mb-1">
                  Platba nebyla dokončena
                </h2>
                <p className="text-sm">
                  Platební proces byl zrušen nebo nedokončen. Můžete to zkusit znovu.
                </p>
                {orderId && (
                  <p className="text-xs mt-2 opacity-75">
                    ID objednávky: {orderId}
                  </p>
                )}
              </div>

              <button
                type="button"
                onClick={closeStripeMessage}
                className="text-sm font-medium opacity-70 hover:opacity-100"
                aria-label="Zavřít oznámení"
              >
                Zavřít
              </button>
            </div>
          </div>
        </div>
      )}

      <main>
        <HeroSection />
        <HowItWorksSection />
        <PartnerskaSection />
        <RozluckovaSection />
        <PricingSection />
        <ExamplesSection />
        <FAQSection />
        <ContactSection />
      </main>

      <Footer />
      <CookieBanner />
    </div>
  );
};

export default LandingPage;